import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';

class WayBillDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'issue_created_at',
        type: String,
        validators: {},
        labelKey: 'issue_created_at',
      },
      {
        name: 'issue_created_at_to',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_to',
      },
      {
        name: 'issue_created_at_from',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_from',
      },
      {
        name: 'issue_start',
        type: String,
        validators: {},
        labelKey: 'issue_start',
      },
      {
        name: 'issue_start_to',
        type: String,
        validators: {},
        labelKey: 'issue_start_to',
      },
      {
        name: 'issue_start_from',
        type: String,
        validators: {},
        labelKey: 'issue_start_from',
      },
      {
        name: 'issue_end',
        type: String,
        validators: {},
        labelKey: 'issue_end',
      },
      {
        name: 'issue_end_to',
        type: String,
        validators: {},
        labelKey: 'issue_end_to',
      },
      {
        name: 'issue_end_from',
        type: String,
        validators: {},
        labelKey: 'issue_end_from',
      },
      {
        name: 'issue_valid_until',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until',
      },
      {
        name: 'issue_valid_until_to',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_to',
      },
      {
        name: 'issue_valid_until_from',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_from',
      },
      {
        name: 'vehicle_brand',
        type: String,
        validators: {},
        labelKey: 'vehicle_brand',
      },
      {
        name: 'carrier',
        type: String,
        validators: {},
        labelKey: 'carrier',
      },
      {
        name: 'grn_ts',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
      // Дополнил исходя из названий полей в журнале иных сведений
      {
        name: 'vehicle_external_id',
        type: String,
        validators: [],
        labelKey: 'vehicle.external_id',
      },
      {
        name: 'carrier_external_id',
        type: String,
        validators: [],
        labelKey: 'carrier.external_id',
      },
      {
        name: 'waybill_dispatched_at',
        type: String,
        validators: [],
        labelKey: 'issue_start',
      },
      {
        name: 'waybill_returned_at',
        type: String,
        validators: [],
        labelKey: 'issue_end_way',
      },
      {
        name: 'waybill_valid_from_date',
        type: String,
        validators: [],
        labelKey: 'effective_date',
      },
      {
        name: 'waybill_valid_until_date',
        type: String,
        validators: [],
        labelKey: 'expiration_date',
      },
      {
        name: 'driver_external_id',
        type: String,
        validators: [],
        labelKey: 'driver.external_id',
      },
      {
        name: 'waybill_pre_trip_medical_exam_result',
        type: String,
        validators: [],
        labelKey: 'pre_trip_medical_examination',
      },
      {
        name: 'waybill_medical_examiner',
        type: String,
        validators: [],
        labelKey: 'pre_trip_responsible',
      },
      {
        name: 'waybill_pre_trip_medical_exam_location',
        type: String,
        validators: [],
        labelKey: 'pre_trip_medical_exam_location',
      },
      {
        name: 'waybill_pre_trip_medical_exam_at',
        type: String,
        validators: [],
        labelKey: 'pre_trip_date',
      },
      {
        name: 'waybill_pre_trip_medical_exam_at_time',
        type: String,
        validators: [],
        labelKey: 'pre_trip_time',
      },
      {
        name: 'waybill_post_trip_medical_exam_result',
        type: String,
        validators: [],
        labelKey: 'post_trip_medical_examination',
      },
      {
        name: 'waybill_post_medical_examiner',
        type: String,
        validators: [],
        labelKey: 'post_trip_responsible',
      },
      {
        name: 'waybill_post_trip_medical_exam_at',
        type: String,
        validators: [],
        labelKey: 'post_trip_date',
      },
      {
        name: 'waybill_post_trip_medical_exam_at_time',
        type: String,
        validators: [],
        labelKey: 'post_trip_time',
      },
      {
        name: 'waybill_post_trip_medical_exam_location',
        type: String,
        validators: [],
        labelKey: 'post_trip_medical_exam_location',
      },
      {
        name: 'waybill_pre_trip_inspection_result',
        type: String,
        validators: [],
        labelKey: 'pre_trip_control',
      },
      {
        name: 'waybill_technical_inspection_location',
        type: String,
        validators: [],
        labelKey: 'pre_trip_technical_exam_location',
      },
      {
        name: 'waybill_pre_trip_inspection_at',
        type: String,
        validators: [],
        labelKey: 'post_trip_control_date',
      },
      {
        name: 'waybill_pre_trip_inspection_at_time',
        type: String,
        validators: [],
        labelKey: 'post_trip_control_time',
      },
      {
        name: 'waybill_technical_inspection_controllers_info',
        type: String,
        validators: [],
        labelKey: 'mechanic',
      },
      {
        name: 'waybill_odometer_dispatch',
        type: String,
        validators: [],
        labelKey: 'odometer_before_trip',
      },
      {
        name: 'waybill_odometer_return',
        type: String,
        validators: [],
        labelKey: 'odometer_after_trip',
      },
      {
        name: 'waybill_odometer_handover',
        type: String,
        validators: [],
        labelKey: 'odometer_handover',
      },
      {
        name: 'waybill_transportation_type',
        type: String,
        validators: [],
        labelKey: 'waybill_transportation_type',
      },
      {
        name: 'waybill_route_type',
        type: String,
        validators: [],
        labelKey: 'waybill_route_type',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default WayBillDTO;
